var React = require('react');

function Dec (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.83,10.83H4.17V9.17H15.83Z","transform":"translate(-4.17 -9.17)","style":{"fill":"#000"}}));
}

Dec.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 11.67 1.67"};

module.exports = Dec;

Dec.default = Dec;
